/* eslint-disable */
import { produce } from "immer";
import {
  FOOTER_CONTENT_FETCH_FAILURE,
  FOOTER_CONTENT_FETCH_START,
  FOOTER_CONTENT_FETCH_SUCCESS,
} from "../actions/types";

const footerContentReducer = (
  state = {
    footerContentFetching: false,
    footerContentData: {},
    footerContentError: null,
  },
  action,
) => {
  switch (action.type) {
    case FOOTER_CONTENT_FETCH_START:
      return produce(state, (draft) => {
        draft.footerContentFetching = true;
      });
    case FOOTER_CONTENT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.footerContentFetching = true;
        draft.footerContentData = action.data;
        draft.footerContentFetching = false;
      });
    case FOOTER_CONTENT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.footerContentFetching = false;
        draft.footerContentError = action.error;
      });
    default:
      return state;
  }
};

export default footerContentReducer;
